import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Rsvp from './Rsvp';

// as of (well probably well before) 09 - 25 userse have all been safely migrated. Removing old RSVP code. - jill

function RsvpBase() {
  return <Rsvp />;
}

RsvpBase.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  enableEventsV2: PropTypes.bool
};

const mapStateToProps = state => ({
  enableEventsV2: state.publicWebsite.wedding.enable_events_v2
});

export default connect(
  mapStateToProps
)(RsvpBase);



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/RsvpBase.jsx